import Log from '~/_Utility/Log';

import Async from '~/Async';

class TextToggle {

    /**
     * @since 2.17.0
     * @method constructor
     */
    constructor() {
        // Set up variables
        this.selector = '[data-p3-text-toggle]';

        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @since 2.17.0
     * @method init
     * @return void
     */
    init() {
        // Let them know we made it here OK
        new Log('TextToggle initialized.', 'init');

        // If there are no matching elements, bail out
        if (!this.selector || !$(this.selector).length)
            return;

        // Search for elements
        $(this.selector).each((i, ele) => {

            // Declare and initialize
            let element = $(ele);
            let toggle  = element.data('p3-text-toggle');
            let revert  = element.data('p3-text-toggle-revert');
            let init    = 'on' === element.data('p3-text-toggle-init');

            // If the revert is missing, use the current text
            if (!revert) {

                // Set the value for later access
                element.data('p3-text-toggle-revert', element.text().trim());

                // Try to pull it again
                revert = element.data('p3-text-toggle-revert');

            }

            // If already initialized, we are done here
            if (init)
                return;

            // Add the click listener
            element.on('click', () => {

                // Check the state
                let on = 'on' === element.data('p3-text-toggle-state');

                // Toggle text on/off based on state
                element.text(on ? revert : toggle);

                // Toggle the state
                element.data('p3-text-toggle-state', on ? 'off' : 'on');

            });

            // Set the initialization flag
            element.data('p3-text-toggle-init', 'on');
        });
    }
}

export default TextToggle;